module.exports = __webpack_public_path__ + "static/media/BladeHW_U-Hook_adapter.a34b045b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/wiper-blades-adapters/BladeHW_U-Hook_adapter.jpg
// module id = 810
// module chunks = 0